"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
const Note = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M3 3.75c0-.207.086-.394.222-.53A.731.731 0 0 1 3.751 3h16.498a.748.748 0 0 1 .737.895c.01.047.014.096.014.146v9.818a.735.735 0 0 1-.065.304.741.741 0 0 1-.213.376l-6.4 6.2a.736.736 0 0 1-.563.261H3.72a.734.734 0 0 1-.72-.75V3.75zm1.5.75v15h8.55V14a.75.75 0 0 1 .75-.75h5.7V4.5h-15z", children: " " })
] });
var Note_default = Note;
export {
  Note_default as default
};
